export function findIdByPath(currentPath, level) {
  let routes = JSON.parse(sessionStorage.getItem("mk_head_menu_List")) || []
  for (const route of routes) {
    if (currentPath.indexOf(route.url) > -1) {
      let param = { 
        pid: route.id,
        level: level
      }
      return param
    }
  }
  return null
}

// 左侧菜单链接缓存 key（由 leftMenuList 拉取后落库）
const LEFT_MENU_LINKS_KEY = "mk_left_menu_links";

/**
 * 菜单数据全局落库：递归收集所有叶子节点的跳转路径（link 优先，回退 url），
 * 供全局 mixin 判断「目标路由是否为详情页」使用。
 * 详情页（edit/report/design/channel 等）不在菜单里，不会被收集进来。
 */
export function cacheLeftMenuLinks(menuList) {
  const links = [];
  const walk = (list) =>
    (list || []).forEach((item) => {
      if (item.children && item.children.length) {
        walk(item.children);
      } else if (item.link || item.url) {
        links.push(item.link || item.url);
      }
    });
  walk(menuList);
  try {
    sessionStorage.setItem(LEFT_MENU_LINKS_KEY, JSON.stringify(links));
  } catch (e) {}
}

/**
 * 判断某个路由 path 是否为左侧菜单页面（非详情页）。
 */
export function isInLeftMenu(path) {
  try {
    const links = JSON.parse(sessionStorage.getItem(LEFT_MENU_LINKS_KEY) || "[]");
    return links.indexOf(path) >= 0;
  } catch (e) {
    return false;
  }
}
